import {createSlice} from "@reduxjs/toolkit";

const DashboardSlice = createSlice({
    name: "dashboard",
    initialState: {
        donor: "All",
        region: "All",
        sro: "All",
        sector: "All"
    },
    reducers: {
        setFilterParams: (state, action) => {
            state.donor = "donor" in action.payload ? action.payload["donor"] : "All";
            state.region = "region" in action.payload ? action.payload["region"] : "All";
            state.sro = "sro" in action.payload ? action.payload["sro"] : "All";
            state.sector = "sector" in action.payload ? action.payload["sector"] : "All";

        },
    }
});

export const dashboardActions = DashboardSlice.actions;

export const dashboardReducer = DashboardSlice.reducer;
